import request from '../../utils/network/request';

const handleImport = (service: string) => {
  const searchParams = new URLSearchParams();
  searchParams.set('redirect_path', document.location.pathname);
  const queryString = searchParams.toString();

  request(`/api/${service}/import?${queryString}`, 'GET').then((data) => {
    document.location = (data as { url: string }).url;
  });
};

export default handleImport;
